import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/npm': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M288 288H256V224H288V288zM576 160V352H288V384H160V352H0V160H576zM160 192H32V320H96V224H128V320H160V192zM320 192H192V352H256V320H320V192zM544 192H352V320H416V224H448V320H480V224H512V320H544V192z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/npm.js
// module id = zOg1
// module chunks = 144